
import { Button } from 'react-admin';
// import Iframe from 'react-iframe'
import { useParams } from 'react-router-dom';
import DisplayScheduleButton from './DisplayScheduleButton';
import { Box } from '@mui/material';
import { getToken } from '../authentication/authProvider';
import { useState } from 'react';
// @ts-ignore
import Iframe from "@nicholasadamou/react-iframe";
import { useMediaQuery, Theme } from '@mui/material';


const PAPERMAN_API_URL = process.env.REACT_APP_PAPERMAN_API_URL;

const Schedule = () => {

    const isXSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
      );

    let { date } = useParams();

    if(date == undefined){
        date = new Date().toISOString().replace(/T.*/,'').split('-').join('-');
    }
    const scheduleUrl = `${PAPERMAN_API_URL}funerals/en/${date}?accessToken=${getToken()}`

    return(
        <>
        {isXSmall ? undefined :
        <Box sx={{mt: '20px', mb: '10px'}}>
        <DisplayScheduleButton />
        </Box>
        }
        <Iframe 
        src={scheduleUrl}
        position="absolute"
        width="100%"
        id="myId"
        className="myClassname"
        height="100%"
        frameBorder={0}
        />
        </>
        
    );

}



export default Schedule;
